module.exports = __webpack_public_path__ + "img/depechmode.857dcf9e.jpg";